import type { Actor } from "@/modules/access";

/** The suffix a scan reference gets when the paper carries the printed code of a form SAADS generated (so the scan replaces it under the same code). */
const PRINTED = "~printed";
/** The suffix of a scan whose paper carries a printed code that is NOT the expected one: it is kept as a new document under a new code and the old code's place (the page footer) is whited out. */
const REDACT = "~redact";
/** The suffix of a scan whose paper carries another existing code, proved with its key: the scan is kept under that very code (`~as:<CODE>`). */
const AS = "~as:";
export const printedRef = (ref: string, printed: boolean, redact = false, asCode = "") => ref + (printed ? PRINTED : "") + (redact ? REDACT : "") + (asCode ? AS + asCode : "");
export function splitPrintedRef(given: string): { ref: string; printed: boolean; redact: boolean; asCode: string } {
  const as = /~as:([A-Za-z0-9-]{1,80})$/.exec(given);
  const noAs = as ? given.slice(0, as.index) : given;
  const redact = noAs.endsWith(REDACT);
  const rest = redact ? noAs.slice(0, -REDACT.length) : noAs;
  const printed = rest.endsWith(PRINTED);
  return { ref: printed ? rest.slice(0, -PRINTED.length) : rest, printed, redact, asCode: as?.[1]?.toUpperCase() ?? "" };
}

/** Something a scanned PDF can be uploaded into, offered by a module (decision 0356): `kind` names it, `ref` says which one (a token is bound to one `kind:ref`). */
export type ScanTarget = {
  kind: string;
  /** Whether this person may upload into `ref` (checked when the pass is made). */
  mayScan: (actor: Actor, ref: string) => Promise<boolean>;
  /** The code printed on the paper this owner is expected to hand back (their latest generated form), or null; used to check what the person reads off the paper. */
  expectedCode?: (ref: string) => Promise<string | null>;
  /** Stores the file (`scannedBy` is the email of the person who made the pass); `invalid` for a file the module refuses (type, size), `error` for anything else. */
  store: (ref: string, file: { filename: string; bytes: Buffer }, scannedBy: string) => Promise<"saved" | "invalid" | "error">;
};
